// import React, { useState, useRef } from "react";
// import Div100vh from "react-div-100vh";

// import { trackBtnClick } from "@/lib/helper";
// import { motion } from "framer-motion";
// import PrimaryButton from "@/components/common/buttons/PrimaryButton";
// import BackgroundImage from "@/assets/images/landlord-background.png";
// import ThunderVideo from "@/assets/videos/thunder-video(1).mp4";
// import CongratsFallbackImg from "@/assets/images/congratulations-image.png";
// import { ArrowRight } from "lucide-react";

// function VideoWithPlaceholder() {
//   const [isVideoLoaded, setIsVideoLoaded] = useState(false);
//   const videoRef = useRef(null);

//   return (
//     <div className="relative w-full h-72">
//       {" "}
//       <img
//         src={CongratsFallbackImg}
//         alt="Loading placeholder"
//         className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-500 scale-5 ${
//           isVideoLoaded ? "opacity-0" : "opacity-100"
//         }`}
//       />
//       <video
//         ref={videoRef}
//         width="100%"
//         height="100%"
//         autoPlay
//         muted
//         loop
//         playsInline
//         preload="auto"
//         onLoadedData={() => setIsVideoLoaded(true)}
//         className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
//           isVideoLoaded ? "opacity-100" : "opacity-0"
//         }`}
//       >
//         <source src={ThunderVideo} type="video/mp4" />
//         Your browser does not support the video tag.
//       </video>
//     </div>
//   );
// }

// const steps = [
//   {
//     number: 1,
//     title: "Find a new rental home.",
//     description: "",
//   },
//   {
//     number: 2,
//     title: "Extend the club invite to your new landlord.",
//     description: "",
//   },
//   {
//     number: 3,
//     title:
//       "Our expert connects with you & then onboards your landlord with exclusive club benefits.",
//     description: "",
//   },
// ];

// export default function CongratsScreen() {
//   return (
//     <Div100vh className="relative flex flex-col justify-between items-start bg-[#000] overflow-x-hidden">
//       <div
//         className="absolute inset-0 z-[9999] pointer-events-none"
//         style={{
//           backgroundImage: `url(${BackgroundImage})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//         }}
//       ></div>
//       <div className="flex flex-col gap-4 sm:gap-8 justify-center se:mt-8 sm:mt-12 items-center">
//         <motion.span
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ duration: 0.8, ease: "easeInOut" }}
//           className="text-white text-2xl font-semibold text-left flex flex-col items-center justify-center w-full mt-4"
//         >
//           <span className="text-2xl font-normal bg-gradient-to-r from-[#888888] via-[#FFFFFF] to-[#888888] bg-clip-text text-transparent">
//             CONGRATULATIONS
//           </span>
//           <hr className=" h-[2px] border-0 bg-gradient-to-r from-[#010101] via-[#999] to-[#010101] my-4 z-[9999] w-1/2" />

//           <span className="capitalize text-xl font-medium bg-gradient-to-r from-[#888888] via-[#FFFFFF] to-[#888888] bg-clip-text text-transparent leading-tight">
//             Journey to Zero Deposit
//             {/* Circle <span className="text-[#1987FB]">Pe </span>Club */}
//           </span>
//         </motion.span>
//         {/* <VideoWithPlaceholder /> */}
//         <div className="py-2  p-6 sm:px-8">
//           <div className="flex flex-col gap-6 bg-black text-white">
//             {steps.map((step) => (
//               <motion.div
//                 initial={{ opacity: 0 ,y:50}}
//                 animate={{ opacity: 1, y:20 }}
//                 transition={{ duration: 0.8, ease: "easeInOut" }}
//               >
//                 <div className="p-[0.5px] bg-gradient-to-b from-[#bbb] via-[#444] to-[#000]">
//                   <div
//                     key={step.number}
//                     className="flex items-center py-3 px-6 sm:p-6  bg-gradient-to-b from-[#171717] to-[#000]"
//                   >
//                     {/* Step Number */}
//                     <div className="flex flex-col items-start text-3xl sm:text-5xl font-medium text-white mr-6 text-center">
//                       {step.number}
//                     </div>

//                     {/* Step Details */}
//                     <div className={`${step.number === 1 ? "ml-2" : ""}`}>
//                       <h2 className="text-base font-normal leading-6">
//                         {step.title}
//                       </h2>
//                       <p className="text-gray-400 text-2xs mt-2">
//                         {step.description}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </div>

//       <div className="flex flex-col w-full px-8 mb-6 sm:mb-10">
//         <PrimaryButton
//           handleClick={() => {
//             trackBtnClick("Done", "Congrats Screen");
//             window.location.href = "/";
//           }}
//           text="Enter The Club"
//         />
//       </div>
//       {/*  */}
//     </Div100vh>
//   );
// }

import React, { useState, useRef } from "react";
import Div100vh from "react-div-100vh";

import { trackBtnClick } from "@/lib/helper";
import { motion } from "framer-motion";
import PrimaryButton from "@/components/common/buttons/PrimaryButton";
import BackgroundImage from "@/assets/images/landlord-background.png";
import ThunderVideo from "@/assets/videos/thunder-video(1).mp4";
import CongratsFallbackImg from "@/assets/images/congratulations-image.png";

function VideoWithPlaceholder() {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const videoRef = useRef(null);

  return (
    <div className="relative w-full h-72 overflow-hidden">
      <img
        src={CongratsFallbackImg}
        alt="Loading placeholder"
        className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-500 transform ${
          isVideoLoaded ? "opacity-0 scale-100" : "opacity-100 scale-150"
        }`}
        style={{
          transformOrigin: "center",
        }}
      />
      <video
        ref={videoRef}
        width="100%"
        height="100%"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        onLoadedData={() => setIsVideoLoaded(true)}
        className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
          isVideoLoaded ? "opacity-100" : "opacity-0"
        }`}
      >
        <source src={ThunderVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}

export default function CongratsScreen() {
  return (
    <Div100vh className="relative flex flex-col justify-between items-center py-4 bg-[#000] overflow-y-hidden overflow-x-hidden">
      <div
        className="absolute inset-0 z-[9999] pointer-events-none"
        style={{
          backgroundImage: `url(${BackgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
      <motion.span
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 60 }}
        transition={{ duration: 0.8 }}
        className="text-white text-2xl font-semibold text-center mb-4"
      >
        <span className="text-xl font-normal bg-gradient-to-r from-[#888888] via-[#FFFFFF] to-[#888888] bg-clip-text text-transparent">
          CONGRATULATIONS
        </span>
        <hr className="w-full h-[1px] border-0 bg-gradient-to-r from-[#010101] via-[#FFFFFF] to-[#010101] my-4 z-[9999]" />
      </motion.span>
      <VideoWithPlaceholder />
      <div className="flex flex-col gap-8 w-full px-8 mt-4">
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="flex flex-col font-semibold text-lg text-center"
        >
          <span className="font-light text-lg">Welcome to</span>
          <span className="text-xl">
            Circle<span className="text-[#1987FB]">Pe </span>Club
          </span>
        </motion.span>
        <PrimaryButton
          handleClick={() => {
            trackBtnClick("Done", "Congrats Screen");
            window.location.href = "/";
          }}
          text="Done"
        />
      </div>
    </Div100vh>
  );
}
